import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const wrapper = css`
  margin-top: 0.5rem;
`;

export const expirationMessage = (theme: Theme) => css`
  color: ${theme.danger.textBase};
  font-style: italic;
`;
